const LIGHT_THEME_DEFAULTS = {
    bg_color: '#ffffff',
    secondary_bg_color: '#f2f2f7',
    subtitle_text_color: '#6d6d72',
    link_color: '#2481cc',
    hint_color: '#8e8e93',
    text_color: '#000000'
};

const DARK_THEME_DEFAULTS = {
    bg_color: '#000000',
    secondary_bg_color: '#1c1c1e',
    subtitle_text_color: '#8e8e93',
    link_color: '#64b5ef',
    hint_color: '#8e8e93',
    text_color: '#ffffff'
};

const validColor = (value, fallback) => (
    typeof value === 'string' && value.trim().length > 0 ? value : fallback
);

export const resolveTelegramTheme = (themeParams = {}, colorScheme = 'light') => {
    const defaults = colorScheme === 'dark' ? DARK_THEME_DEFAULTS : LIGHT_THEME_DEFAULTS;

    return Object.keys(defaults).reduce((theme, key) => ({
        ...theme,
        [key]: validColor(themeParams?.[key], defaults[key])
    }), {});
};
